import { Injectable } from '@angular/core';
import { RequestOptions } from '@angular/http';

import { CommonRequestService } from './common-request.service';
import { UserService } from './user.service';
import { AppSettings } from './../app.settings';

export interface LbLrs {
	customerId: number;
	projectId: number;
	id: number;
	name: string;
	uomMeas: string; // ??
	measPrecision: number; // the position of measure
	description: string;
	layerId: number;
	isDefault: boolean;
	isMultiJuris: boolean;
}
export interface UpdateLrsParams {
	id: Number;
	name: string;
	default: boolean;
	uomMeasures?: string;
	description?: string;
	measurePrecision?: number;
}
@Injectable()
export class LrsService {

	constructor(
		private requestService: CommonRequestService,
		private userService: UserService
	) { }
	updateLrs(params: LbLrs, successCallback?, errorCallback?) {
		const url = AppSettings.serviceRootUrl + 'lbo/lrs';
		const body: UpdateLrsParams = {
			id: params.id,
			name: params.name,
			default: true,
			uomMeasures: params.uomMeas ? params.uomMeas : ' ',
			description: params.description ? params.description : ' ',
			measurePrecision: params.measPrecision ? params.measPrecision : 0
		};
		this.requestService.requestPut(url, body, (rsp) => {
			if (successCallback) {
				successCallback();
			}
		}, errorCallback);
	}
	getLrs(successCallback?: (lrs: LbLrs[]) => any, errorCallback?): void {
		const url = AppSettings.serviceRootUrl + 'lbo/lrs';
		const options = new RequestOptions({
			params: {
				customerId: this.userService.getUserInfo().customerId
			}
		});
		this.requestService.requestGet(url, options, (rsp) => {
			if (successCallback) {
				const lrsArr = this.handleGetLrs(rsp.data);
				successCallback(lrsArr);
			}
		}, errorCallback);
	}
	private handleGetLrs(data): LbLrs[] {
		const lrsArr: LbLrs[] = [];
		if (data) {
			data.forEach((d) => {
				lrsArr.push({
					customerId: d.cus_id,
					projectId: d.prj_id,
					id: d.ors_id,
					name: d.ors_name,
					uomMeas: d.lrs_meas_uom,
					layerId: d.ole_id,
					description: d.ors_desc,
					measPrecision: d.ors_meas_precision,
					isMultiJuris: d.ors_multi_juris,
					isDefault: d.ors_default,
				});
			});
		}
		return lrsArr;
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/lrs.service.ts